export default __webpack_public_path__ + "static/media/1.8feb7e35.png";